import { render, staticRenderFns } from "./ModelPopUp.vue?vue&type=template&id=5c438dfb&scoped=true&"
import script from "./ModelPopUp.vue?vue&type=script&lang=js&"
export * from "./ModelPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ModelPopUp.vue?vue&type=style&index=0&id=5c438dfb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c438dfb",
  null
  
)

export default component.exports